var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
export class DataTemplates {
  /**
   * Creates an instance of DataTemplates.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof DataTemplates
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetMpTemplateVersionRq_ _getMpTemplateVersionRq
   * @returns Promise<GetMpTemplateVersionRq_>
   * @memberof DataTemplates
   */
  getMpTemplateVersion(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/DataTemplates/mptemplateversion", "GET", "application/json; charset=UTF-8", "application/json", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200 }, { statusCode: 403, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
